"use client";

import { UserRound, X } from "lucide-react";
import {
  FALLBACK_INSTRUCTOR_VRM,
  FALLBACK_VRM_FEMALE,
  FALLBACK_VRM_MALE,
} from "@/lib/classroom/avatarDefaults";

interface AvatarCreatorModalProps {
  onClose: () => void;
  onAvatarCreated: (url: string) => void;
}

const AVATARS = [
  {
    label: "여성 캐릭터",
    description: "학생용 기본 아바타",
    url: FALLBACK_VRM_FEMALE,
    color: "bg-rose-50 text-rose-600",
  },
  {
    label: "남성 캐릭터",
    description: "학생용 기본 아바타",
    url: FALLBACK_VRM_MALE,
    color: "bg-blue-50 text-blue-600",
  },
  {
    label: "코치 캐릭터",
    description: "강사·코치용 아바타",
    url: FALLBACK_INSTRUCTOR_VRM,
    color: "bg-violet-50 text-violet-600",
  },
] as const;

export default function AvatarCreatorModal({
  onClose,
  onAvatarCreated,
}: AvatarCreatorModalProps) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 p-4">
      <div className="relative w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute right-3 top-3 rounded-full p-2 text-gray-500 hover:bg-gray-100"
          aria-label="닫기"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="pr-8">
          <h2 className="text-lg font-bold text-gray-950">아바타 선택</h2>
          <p className="mt-1 text-sm text-gray-500">
            강의실에서 사용할 캐릭터를 선택하세요. 색상은 선택 후 스타일에서
            꾸밀 수 있어요.
          </p>
        </div>

        <div className="mt-5 grid gap-3 sm:grid-cols-3">
          {AVATARS.map(avatar => (
            <button
              key={avatar.url}
              type="button"
              onClick={() => onAvatarCreated(avatar.url)}
              className="rounded-2xl border border-gray-200 p-4 text-left transition hover:border-violet-300 hover:bg-violet-50/40 hover:shadow-sm"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-full ${avatar.color}`}
              >
                <UserRound className="h-7 w-7" />
              </span>
              <span className="mt-3 block text-sm font-bold text-gray-900">
                {avatar.label}
              </span>
              <span className="mt-1 block text-xs text-gray-500">
                {avatar.description}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
